import { useContext } from 'react';
import { RelationsContext } from './RelationsContext';

export const useProductRelations = () => {
  const context = useContext(RelationsContext);

  if (context === undefined) {
    throw new Error(
      'useProductRelationsProduct must be within the Context Provider'
    );
  }
  return context;
};
